<h1 mat-dialog-title>
  <span> {{ data["title"] }} </span>
</h1>
<div mat-dialog-content>
  <p [innerHtml]="data['message']"></p>
</div>
<div mat-dialog-actions>
  <app-button (Click)="onNoClick()" Text="انصراف" Appearance="default" />
  <app-button (Click)="logout()" Text="تایید" Appearance="accent" />
</div>
